import { useMutation, useQueryClient } from 'react-query';
import { API } from 'api';
import { getLatestQuery } from 'common';
import { toastPush } from 'modules';
import { useDispatch } from 'react-redux';

export interface IAddHlbbReportData {
  payload: {
    bank: string;
    fileName: string;
    data: string;
    type: string;
  };
}

const addHlbbReportData = (payload: IAddHlbbReportData['payload']) => {
  const formData = new FormData();
  formData.append('data', payload.data || '');
  formData.append('type', payload.type || '');
  return API.newPost('/api/admin/financeFiles/HLBB', formData, {
    'Content-Type': 'multipart/form-data',
  });
};

export const useAddHlbbReportData = () => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();
  const key = 'hlbbReports';
  const queryArr = queryClient.getQueriesData(key);
  const res = getLatestQuery(queryArr, queryClient);

  return useMutation(addHlbbReportData, {
    onSuccess: () => {
      dispatch(
        toastPush({
          code: 200,
          type: 'success',
          title: 'SUCCESS',
          body: 'toastPush.createdSuccessful',
        })
      );
      return queryClient.invalidateQueries(key, res.queryParams);
    },
  });
};
